import "./topbar.css";
import LogoutIcon from "@mui/icons-material/Logout";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { useNavigate } from "react-router-dom";
import {
  hasAdminRole,
  hasMultiApplicationAccess,
  parseStoredAppRoleIds,
  parseStoredRoleIds,
} from "../../utils/authAccess";

export default function Topbar({
  title = "DB EDITOR",
  showLogout = true,
  showAppSwitch = true,
  showAdminAccess = true,
}) {
  const navigate = useNavigate();
  const appRoleIds = parseStoredAppRoleIds(localStorage.getItem("appRoleIds"));
  const roleIds = parseStoredRoleIds(localStorage.getItem("roleId"));
  const canSwitchApp = showAppSwitch && hasMultiApplicationAccess(appRoleIds);
  const canOpenAdminAccess = showAdminAccess && hasAdminRole(roleIds);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const handleSwitchApplication = () => {
    navigate("/application-selector");
  };

  const handleOpenAdminAccess = () => {
    navigate("/admin-access");
  };

  return (
    <div className="topbarContainer">
      <div className="topbarLeft">
        <img src="/assets/shs-header-logo.png" alt="Logo" className="logoImg" />
      </div>
      <div className="topbarCenter">
        <span className="appname">{title}</span>
      </div>
      <div className="topbarRight">
        {canOpenAdminAccess ? (
          <button className="logoutButton adminAccessButton" onClick={handleOpenAdminAccess}>
            <AdminPanelSettingsIcon style={{ marginRight: "6px" }} />
            Admin Controls
          </button>
        ) : null}
        {canSwitchApp ? (
          <button className="logoutButton switchAppButton" onClick={handleSwitchApplication}>
            <SwapHorizIcon style={{ marginRight: "6px" }} />
            Switch App
          </button>
        ) : null}
        {showLogout ? (
          <button className="logoutButton" onClick={handleLogout}>
            <LogoutIcon style={{ marginRight: "6px" }} />
            Logout
          </button>
        ) : null}
      </div>
    </div>
  );
}
